module.exports = __webpack_public_path__ + "assets/img/image-hero.1911d365.jpg";